import { ConceptMatch } from "@/tools/msa/models/concepts";

const FORBIDDEN_WORDS = ["provider", "attending", "physician", "name"];

const containsForbiddenWord = (text: string) =>
  FORBIDDEN_WORDS.some(word =>
    text.toLocaleLowerCase().includes(word.toLocaleLowerCase())
  );

export const PROVIDER_NAME: Array<(match: ConceptMatch) => boolean> = [
  (match: ConceptMatch) =>
    match.text
      .split(/\s+/)
      .filter(name => !containsForbiddenWord(name))
      .filter(name => name.length > 3).length >= 2,
  (match: ConceptMatch) => !containsForbiddenWord(match.text),
  (match: ConceptMatch) =>
    Boolean(match.labels) && match.labels!.includes("signing_dr"),
  (match: ConceptMatch) =>
    match.text
      .split(/\s+/)
      .filter(name => !containsForbiddenWord(name))
      .filter(name => name.length > 3).length < 4,
  (match: ConceptMatch) =>
    match.text
      .toLocaleLowerCase()
      .split(/\s+/)
      .map(name => name.replace(/\W/g, ""))
      .some(name => ["md", "do"].includes(name))
];
